import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { JwtInterceptor } from './core/interceptors/auth.interceptor';
import { InviteWorkerComponent } from './features/users/invite-worker/invite-worker/invite-worker.component';
import { WorkersListComponent } from './features/users/invite-worker/workers-list/workers-list.component';
import { DashboardComponent } from './features/dashboard/dashboard/dashboard.component';
import { DashboardLayoutComponent } from './layout/dashboard-layout/dashboard-layout.component';
import { LiveMapComponent } from './features/dashboard/live-map/live-map.component';
import { RefreshInterceptor } from './core/interceptors/refresh.interceptor';
import { JobsModule } from './features/jobs/jobs.module';
import { TaskLogComponent } from './features/logs/task-log/task-log.component';
import { ReportsComponent } from './features/reports/reports.component';
import { NotFoundComponent } from './features/not-found/not-found.component';
import { SuperadminLayoutComponent } from './features/superadmin/superadmin-layout/superadmin-layout.component';
import { SuperadminDashboardComponent } from './features/superadmin/superadmin-dashboard/superadmin-dashboard.component';
import { SuperadminCompaniesComponent } from './features/superadmin/superadmin-companies/superadmin-companies.component';
import { RouterModule } from '@angular/router';
import { SuperadminCompanyDetailComponent } from './features/superadmin/superadmin-company-detail/superadmin-company-detail.component';
import { SuperadminWorkersComponent } from './features/superadmin/superadmin-workers/superadmin-workers.component';
import { SuperadminJobsComponent } from './features/superadmin/superadmin-jobs/superadmin-jobs.component';
import { CompanyProfileComponent } from './features/company/company-profile/company-profile.component';
import { PricingComponent } from './features/pricing/pricing.component';
import { PaymentSuccessComponent } from './features/payment-success/payment-success.component';
import { SubscriptionStatusComponent } from './shared/components/subscription-status/subscription-status.component';
import { UpgradePromptComponent } from './shared/components/upgrade-prompt/upgrade-prompt.component';
import { LandingComponent } from './features/landing/landing/landing.component';
import { AiInsightsPanelComponent } from './features/ai-insights/ai-insights-panel/ai-insights-panel/ai-insights-panel.component';
import { PrivacyPolicyComponent } from './features/privacy-policy/privacy-policy.component';
import { ContactComponent } from './features/contact/contact.component';


@NgModule({
  declarations: [
    AppComponent,
    InviteWorkerComponent,
    WorkersListComponent,
    DashboardComponent,
    DashboardLayoutComponent,
    LiveMapComponent,
    TaskLogComponent,
    ReportsComponent,
    NotFoundComponent,
    SuperadminLayoutComponent,
    SuperadminDashboardComponent,
    SuperadminCompaniesComponent,
    SuperadminCompanyDetailComponent,
    SuperadminWorkersComponent,
    SuperadminJobsComponent,
    CompanyProfileComponent,
    PricingComponent,
    PaymentSuccessComponent,
    SubscriptionStatusComponent,
    UpgradePromptComponent,
    LandingComponent,
    AiInsightsPanelComponent,
    PrivacyPolicyComponent,
    ContactComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    JobsModule,
    RouterModule
  ],
providers: [
  { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: RefreshInterceptor, multi: true }
],
  bootstrap: [AppComponent]
})
export class AppModule { }